import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { SetupHomeProject } from 'models/setup/home/SetupProject';

/**
 * Home Project List
 */
export const findSetupHomePorject = async () => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/home`,
    serviceName: ServiceName.ELM_BE,
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupHomeProject[];
};
